export const LOADING_COPY = {
  catalog: { verb: "Cargando", word: "catálogo", status: "SINCRONIZANDO INVENTARIO" },
  auctions: { verb: "Cargando", word: "subastas", status: "SINCRONIZANDO PUJAS" },
  auction: { verb: "Cargando", word: "subasta", status: "VERIFICANDO PRECIO EN VIVO" },
  card: { verb: "Cargando", word: "carta", status: "VERIFICANDO DISPONIBILIDAD" },
  stores: { verb: "Cargando", word: "tiendas", status: "CONECTANDO TIENDAS" },
  news: { verb: "Cargando", word: "noticias", status: "ACTUALIZANDO NOTICIAS" },
  inventory: { verb: "Cargando", word: "tu inventario", status: "LEYENDO TU CUENTA" },
  cart: { verb: "Cargando", word: "tu carrito", status: "CALCULANDO TOTALES" },
  profile: { verb: "Cargando", word: "perfil", status: "LEYENDO TU CUENTA" },
  search: { verb: "Buscando", word: "cartas", status: "FILTRANDO RESULTADOS" },
  admin: { verb: "Cargando", word: "panel", status: "LEYENDO REGISTROS" },
  historial: { verb: "Cargando", word: "historial", status: "LEYENDO PRECIOS" },
  legal: { verb: "Cargando", word: "documento", status: "LEYENDO DOCUMENTO" },
};

const mk = (labels) => labels.map((label, i) => ({ n: `0${i + 1}`, label, s: label.toUpperCase() }));

export const STEP_SETS = {
  page: mk(["Conectando con HIT", "Sincronizando inventario", "Verificando precios en vivo", "Revelando tu hit"]),
  publish: mk(["Subiendo fotos", "Validando datos", "Creando publicación", "Listo para revisión"]),
  payment: mk(["Conectando", "Verificando monto", "Procesando", "Confirmado"]),
};
